'use strict';

var template = require('../templates/PayrollHistory.html');
var ItemView = require('./payrollHistory/Item.js');

module.exports = Backbone.View.extend({
    itemViews: null,

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            attachments: null,
            integration: null,
            payrollIntegrations: {}
        });

        this.itemViews = [];
        return this.render();
    },

    render: function() {
        this.$el.html(template({collection: this.collection}));
        this.toggleEmptyLabel();

        if (this.collection) {
            this.collection.each(this.renderPayroll.bind(this));
            this.$('.sk-spinner').hide();
        }

        return this;
    },

    setCollection: function(options) {
        this.collection = options.collection || null;
        this.options.attachments = options.attachments || null;
        this.options.integration = options.integration || null;
        this.options.payrollIntegrations = options.payrollIntegrations || null;

        return this.render();
    },

    renderPayroll: function(model, index) {
        var view = new ItemView({
            model: model,
            attachments: this.options.attachments[model.id],
            integration: this.options.integration,
            payrollIntegration: this.options.payrollIntegrations[model.id]
        });

        this.itemViews.push(view);
        this.$('.payroll-history-items').append(view.$el);

        if (index % 2 === 1) {
            this.$('.payroll-history-items')
                .append('<div class="col-xs-12"></div>');
        }
    },

    toggleEmptyLabel: function() {
        this.$('.empty-list').toggleClass(
            'hidden', !_.isNull(this.collection) || this.collection.length > 0
        );
    },

    remove: function() {
        this.undelegateEvents();
        this.itemViews.forEach(view => view.remove());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/PayrollHistory.js